export const API_URLS = {
  SIGN_UP: '/user/register',
  SIGN_IN: '/login',
  LOG_OUT: '/user/logout',
  
  FORGOT_PASSWORD: '/emailverification',
  FORGOT_PASSWORD_OTP_SENT: '/user/forgot/password/otp',
  FORGOT_PASSWORD_OTP_VERIFY: '/user/forgot/otp/verify',
  CHANGE_PASSWORD: '/user/change/forgot/password',
  USER_PROFILE_LIST: '/user-profile/list',
  USER_PROFILE_SELECT: '/user-profile/select',
  USER_PROFILE_CREATE: '/user-profile/create',
  USER_PROFILE_UPDATE: '/user-profile/update',
  USER_PROFILE_DETAIL: '/user-profile/detail',
  USER_PROFILE_REMOVE: '/user-profile/remove',
  USER_WATCHLIST_LIST: '/user-watchlist-item/list',
  MOVIE_DETIALS: '/movie/detail',
  MORE_LIKE_THIS_MOVIES: '/movie/more-like-this',
  NEW_RELEASE_MOVIES: '/movie/new-release',
  TRENDING_MOVIES: '/movie/trending',
  HOME_SLIDER: '/home/slider',
  TVSHOW_DETAILS: '/tvshow/detail',
  TVSHOW_MORE_LIKE_THIS: '/tvshow/more-like-this',
  TVSHOW_NEW_RELEASE: '/tvshow/new-release',
  TVSHOW_TRENDING: '/tvshow/trending',
  TVSHOW_SEASON_EPISODE: '/tvshow/episode/list',
  MATURITY_LEVEL: '/maturity-level',
  USER_ITEM_WATCHLIST: '/user/watchlist/item/list',
  USER_FAVOURITE_LIST: '/user/favourite/list',
  GENRES_WISE_MOVIES: '/movie/genre-wise',
  GENRES_WISE_TVSHOW: '/tvshow/genre-wise',
  GENRES_LIST: '/genres',
  WATCHLIST_ADD_REMOVE: '/user/watchlist/item/addremove',
  FAVORITE_ADD_REMOVE: '/user/favourite/addremove',
  USER_CHANGE_PASSWORD:'/user/change-password',
  SEARCHDATA:'/search/data',
  PLAY_VIDEO:'/playcontent',
  CONTINUE_WATCHING_LIST:'/continue-watching/list',
  CONTINUE_WATCHING_ADD:'/continue-watching/add',
  TOP_SEARCH_LIST:'/topsearch/list',
  TOP_SEARCH_ADD:'/topsearch/store',
  ACTIVE_ACCOUNT:'/active/account',
  RESEND_CODE:'/activation-code/resend',
  ADVERTISEMENT_URL:'/advertisement/url',
  FEATURES_LIST:'/features/list',
  SUBSCRIPTION_LIST:'/subscriptions/list',
  SUBSCRIPTION_CHECKOUT:'/checkout',
  USER_ACTIVE_PLAN:'/user/active/subscription',
  USER_BILLING_DETAILS:'/subscription/billing/details',
  USER_PLAN_CANCEL:'/subscription/cancel',
  USER_DATA_CAPTURE:'/user/data/capture',
  CLOSE_ACCOUNT_REASON_LIST:'/user/close/account/reason/list',
  CLOSE_ACCOUNT:'/user/close/account',
  

  

  };
  
  export const AUTH_LOCAL_STORAGE_KEY = 'authToken';
  export const API_URL_BASE = 'https://admin-playnow.clonegranny.com/api';
  
  